import { combineReducers } from "redux";
import vehiclesReducer from "./vehicleReducer";
import metricsReducer from "./metricsReducer";
import popupReducer from "./popupReducer";
import labeledVehiclesReducer from "./labeledVehiclesReducer";
import vehicleListReducer from "../actions/vehicleListReducer";
import settingsReducer from "./settingsReducer";
import faultCodesReducer from "./faultCodesReducer";

const rootReducer = combineReducers({
  vehicle: vehiclesReducer,
  metrics: metricsReducer,
  popupView: popupReducer,
  labeledVehicles: labeledVehiclesReducer,
  vehicleList: vehicleListReducer,
  settings: settingsReducer,
  faultCodes: faultCodesReducer,
});

export default rootReducer;

//export type State = ReturnType<typeof rootReducer>;
